module.exports = __webpack_public_path__ + "static/media/pic3.38b12bef.jpg";